import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faMinus } from "@fortawesome/free-solid-svg-icons";

export default function SummaryListItem({ items, listItem, unCheck }) {
  const [iconState, setIconState] = useState(faCheck);
  function handleUnCheck() {
    if (items.some((item) => item.id === listItem.id)) {
      unCheck(items.filter((item) => item.id !== listItem.id));
    } else {
      unCheck([...items, ...listItem.id]);
    }
  }
  return (
    <li
      key={listItem.id}
      onClick={() => handleUnCheck()}
      onMouseOver={() => setIconState(faMinus)}
      onMouseLeave={() => setIconState(faCheck)}
    >
      <FontAwesomeIcon icon={iconState} className="check-icon" />
      <label>
        {Object.keys(listItem)[1] === "format"
          ? listItem.format
          : Object.keys(listItem)[2] === "display_name"
          ? listItem.display_name
          : listItem.name}
      </label>
    </li>
  );
}
